export default "__VITE_ASSET__04ea1ab7__"